import Vue from 'vue'
import { EagleFormConfigInterface } from '@/components/form/types/form'
class formConfig {
  protected vm?: Vue
  protected formKey?: string

  _defaultData() {
    return {
      notify_group_id: null,
    }
  }

  get(vm: Vue, formKey: string) : EagleFormConfigInterface {
    this.vm = vm
    this.formKey = formKey

    return {
      pageTitle: (formMeta: any, formData: AnyObject) => this.vm?.$t('page.app-config.contact'),
      hasWritePermission: (hasRole) : boolean => hasRole(['ROLE_CONTACT']),
      defaultData: this._defaultData,
      blocks: [
        {
          title: 'form_block.base',
          data: {
            notify_group_id: {
              label: 'site_admin_group.to_notify',
              grid: { xl: 12, lg: 12, md: 12 },
              type: 'site-admin-group',
              hasChanged: ({originalData, data, bothEmpty}: FormDataChangeHelperInterface) => {
                if(bothEmpty(originalData, data)) return false
                return originalData != data
              },
            },
          },
        },
      ],
      dataAction: {
        delete: false,
      },
    }
  }
}

export default new formConfig()
